import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './MobileCsMenu.style.css';

const MobileCsMenu = ({ setIsCsOpen }) => {
  const navigate = useNavigate(); // React Router 네비게이션 훅
  const location = useLocation(); // 현재 경로를 가져옴

  const menuItems = [
    { title: 'FAQ', path: '/cs/faq' },
    { title: '공지사항', path: '/cs/notice' },
    { title: '1:1문의', path: '/cs/inquire' },
    //{ title: 'JM Event', path: '/events' },
  ];

  return (
    <div className={`mobile-menu`}>
      <div className="inner">
        <ul>
          {menuItems.map((item, index) => (
            <li
              key={`top_menu_${index}`}
              className={
                location.pathname === item.path ? 'active-menu-item' : ''
              }
              onClick={() => {
                navigate(item.path); // 페이지 이동
                setIsCsOpen(false);
              }}
            >
              {item.title}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MobileCsMenu;
